import React, { useState, useEffect } from "react";

const URLField = ({
  label,
  name,
  value,
  required,
  autoComplete,
  onChange,
  placeholder
}) => {
  const [error, setError] = useState("");

  const validateURL = (url) => {
    if (!url) return required ? "URL is required" : "";
    
    try {
      // Allow empty string or attempt to create valid URL
      if (url.length === 0) return "";
      new URL(url);
      
      // Optional: Add platform-specific validation
      if (name.includes('instagram')) {
        if (!url.includes('instagram.com')) return 'Must be an Instagram URL';
      } else if (name.includes('tik_tok')) {
        if (!url.includes('tiktok.com')) return 'Must be a TikTok URL';
      } else if (name.includes('facebook')) {
        if (!url.includes('facebook.com')) return 'Must be a Facebook URL';
      } else if (name.includes('youtube')) {
        if (!url.includes('youtube.com') && !url.includes('youtu.be')) return 'Must be a YouTube URL';
      } else if (name.includes('hudl')) {
        if (!url.includes('hudl.com')) return 'Must be a Hudl URL';
      }
      
      return "";
    } catch (e) {
      return "Please enter a valid URL (include https://)";
    }
  };

  const handleChange = (event) => {
    const newValue = event.target.value;
    const error = validateURL(newValue);
    setError(error);
    
    if (onChange) {
      onChange({ 
        target: { 
          name: name, 
          value: newValue,
          validationError: error 
        }
      });
    }
  };

  useEffect(() => {
    setError(validateURL(value));
  }, [value]);

  return (
    <div className="url-field-container camper-info-row half">
      {label && <label htmlFor={name}>{label}</label>}
      <input
        id={name}
        name={name}
        type="url"
        required={required}
        autoComplete={autoComplete || "url"}
        placeholder={placeholder || "https://"}
        value={value}
        onChange={handleChange}
        aria-label={label}
        aria-invalid={!!error}
        aria-describedby={error ? `${name}-error` : undefined}
      />
      {error && (
        <span className="error-span" id={`${name}-error`} role="alert">
          {error}
        </span>
      )}
    </div>
  );
};

export default URLField;